import { useState, useEffect } from "react"
import { RFIForm } from "./Form/RFIForm"
import { RFIProps } from "../../interfaces/rfi_types"
import { getRFI } from "../../api/rfi"
import { useNavigate, useParams } from "react-router-dom"
import { useAuth } from "../../App"
import { getProject } from "../../api/projects"
import { EmployeeProps } from "../../interfaces/employee_type"

export function CreateRFI() {
    return (
        <RFIForm method="POST"/>
    )
}

export function EditRFI() {
    const { id } = useParams<string>()

    const [currentRFIData, setCurrentRFIData] = useState<RFIProps>()
    const [loading, setLoading] = useState<boolean>(true)
    const navigate = useNavigate()

    useEffect(() => {
        if (!id) return
        const fetchRFI = async () => {
            try {
                const response = await getRFI(id)

                setCurrentRFIData({...response.data, RFI_id: id})
                setLoading(false)
            } catch (error) {
                console.error("Error fetching RFI:", error)
                navigate("/*")
            }
        }

        fetchRFI()
    }, [id, navigate])

    if (loading) return <div>Loading...</div>

    return (
        <>
            {currentRFIData && <RFIForm method="PUT" RFIProps={currentRFIData}/>}
        </>
    )
}

export function CreateRFIFromProject() {
    const { id } = useParams<string>()
    const { user } = useAuth()

    const [rfi, setRFI] = useState<RFIProps>()

    useEffect(() => {
        if (!id) return

        const get_project = async () => {
            const project = await getProject(id)

            setRFI({
                project: project.data.project_name,
                project_id: project.data.project_id,
                project_name: project.data.project_name + " [" + project.data.client_name + "]",
                category: "Mechanical",
                sent_out_date: new Date().toLocaleDateString('en-CA'),
                date_received: new Date().toLocaleDateString('en-CA'),
                created_by_pk: user?.email ?? "",
                created_by: user as EmployeeProps, 
                assigned_to_pk: "",
                status: "Active",
                description: "",
            })

        }
        get_project()
    }, [id, user])

    return (
        <>
            {rfi && <RFIForm method="POST" RFIProps={rfi}/>}
        </>
    )
}